module.exports = __webpack_public_path__ + "img/photos/placeholders/final-trailer@2x.jpg";